import { LookupBase } from '@singularsystems/neo-core';

export default class LetterAuthorisationSignatureLookup extends LookupBase {

    constructor() {
        super();
        this.makeBindable();
    }

    public signatoryId: number = 0;

    public signatoryName: string = "";

    // Client only properties / methods
}